<script>

/**
 * Vue: USS attn redirect (uss-attn-redirect)
 * -----------------------------------------------------------------------------
 * Redirect users who land on the USS welcome page to an attentive url.
 * - Static section.
 *
 */
export default {
  name: 'UssAttnRedirect',

  props: {
    redirects: {
      type: Array,
      default: () => ([]),
    },
  },

  /**
   * Check if URL parameters match criteria for redirecting user.
   */
  beforeCreate() {
    const params = new URLSearchParams(window.location.search)

    const redirect = this.redirects.find(redirect => {
      const reqs = Object.entries(redirect).filter(entry =>
        entry[1] && entry[0].includes('utm_'),
      )
      return reqs.every(entry => {
        const key = entry[0]
        const value = entry[1]
        const param = params.get(key)

        if (key === 'utm_campaign') {
          const campaigns = value.split(',')
            .map(campaign => campaign.trim())
            .filter(Boolean)

          return campaigns.indexOf(param) > -1
        }

        return param === value
      })
    })

    if (redirect) {
      window.location.href = redirect.url
    }
  },
}
</script>

<style lang="scss">
@import './uss-attn-redirect';
</style>
